// react
import React, {useEffect, useRef, useState} from 'react'
// antd
import {Button, Divider, Drawer, message, Space, Tooltip} from 'antd'
// antd-pro
import {ProForm, ProFormInstance, ProFormItem, ProFormText} from '@ant-design/pro-components'
// less
import './index.less'
// editor
import CodeMirror from '@uiw/react-codemirror'
import {langs} from '@uiw/codemirror-extensions-langs'
import Api from '@/api'
// icon
import {FormatPainterOutlined, FullscreenOutlined} from '@ant-design/icons'
// json 三方库
import JsonBig from 'json-bigint'

interface IProps {
  en?: any
  corpId: string
  close: (reload: boolean) => void
}

/**
 * 流程信息
 * @constructor
 */
const CompanyFlowDrawer = (props: IProps) => {

  const [Open, setOpen] = useState<boolean>(true)
  const formRef = useRef<ProFormInstance>()
  const [EditInfo, setEditInfo] = useState<any>()
  const [FullScreen, setFullScreen] = useState<boolean>(false)

  const close = (reload: boolean) => {
    setOpen(false)
    const _timeOut = setTimeout(() => {
      props.close(reload)
      clearTimeout(_timeOut)
    }, 500)
  }

  /**
   * 获取详情信息
   */
  const getDetail = async () => {
    const _data: any = await Api.Company.FlowDetail({id: props.en.id})
    if (_data) {
      if (_data.config) {
        _data.config = JSON.stringify(_data.config, null, 2)
      }
      setEditInfo(_data)
      formRef.current?.setFieldsValue(_data)
    }
  }

  useEffect(() => {
    props.en && getDetail()
  }, [props.en])

  /**
   * 保存表单
   */
  const saveInfo = () => {
    formRef.current?.validateFields().then(async (res) => {
      try {
        res.config = JsonBig.parse(res.config)
      } catch (e) {
        const _timeOut = setTimeout(() => {
          formRef.current?.setFields([
            {
              name: ['config'],
              errors: ['请输入正确的JSON表达式'],
            },
          ])
          clearTimeout(_timeOut)
        }, 100)
        return
      }
      const _data = await Api.Company.FlowEdit(res)
      if (_data) {
        message.success("保存成功！")
        close(true)
      }
    })
  }

  /**
   * 格式化json
   */
  const formatJson = () => {
    const _json = formRef.current?.getFieldValue("config")
    const _en: any = {
      name: ['config']
    }
    try {
      _en.value = JSON.stringify(JSON.parse(_json), null, 2)
    } catch (e) {
      _en.errors = ['请输入正确的JSON表达式']
    }
    const _timeOut = setTimeout(() => {
      formRef.current?.setFields([_en])
      clearTimeout(_timeOut)
    }, 10)
  }

  return (
    <Drawer
      open={Open}
      onClose={() => close(false)}
      destroyOnClose
      width={"100%"}
      className={"company-flow-drawer"}
      extra={
        <Button type={"primary"} onClick={saveInfo}>保 存</Button>
      }
      keyboard={false}
      title={props.en ? "修改流程" : "添加流程"}
    >
      <ProForm<any>
        submitter={false}
        formRef={formRef}
        labelCol={{
          span: 0,
        }}
        wrapperCol={{span: 15}}
        initialValues={EditInfo}
      >
        <ProFormText hidden name={"id"}/>
        <ProFormText hidden name={"corpId"} initialValue={props.corpId}/>
        <ProFormText
          name={"flowName"}
          label="流程名称"
          placeholder={"请输入流程名称"}
          rules={[{
            required: true,
            message: "流程名称不可为空"
          }]}
        />
        <ProFormText
          name={"flowDesc"}
          label="简介"
          placeholder={"请输入简介"}
        />
        <ProFormText
          name={"flowCode"}
          label={"编码"}
          placeholder={"请输入编码"}
          rules={[{
            required: true,
            message: "请输入编码"
          }]}
        />
        <ProFormItem
          className={FullScreen ? "full-json-edit" : ""}
          label={
            <Space split={<Divider type="vertical" className={"bg-black"}/>}>
              <span>配置</span>
              <Tooltip title={!FullScreen ? "全屏编写" : '收起全屏'}>
                <span
                  className={"cursor-pointer text-[#666666]"}
                  onClick={() => setFullScreen(!FullScreen)}
                >
                 {!FullScreen ? <><FullscreenOutlined/> 全屏</> : <><FullscreenOutlined/> 收起</>}
                </span>
              </Tooltip>
              <Tooltip title={"格式化"}>
                <span
                  className={"cursor-pointer text-[#666666]"}
                  onClick={formatJson}
                >
                 <FormatPainterOutlined/> 格式化
                </span>
              </Tooltip>
            </Space>
          }
          required
          wrapperCol={{
            span: 24
          }}
          name={"config"}
          rules={[{
            required: true,
            message: "配置不可为空"
          }]}
        >
          <CodeMirror
            style={{
              border: '1px solid #d9d9d9',
              position: 'relative',
              zIndex: 20
            }}
            height={FullScreen ? "calc(100vh - 42px)" : "calc(100vh - 410px)"}
            extensions={[langs.json()]}
          />
        </ProFormItem>
      </ProForm>
    </Drawer>
  )
}

export default CompanyFlowDrawer
